function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#06C",
  d: "M11.42 10.452L3.323 4.537l2.308-2.432 9.83 4.054 4.662-4.934C21.169.115 22.079-.24 22.85.158c.449.229.758.576.93 1.039.167.463.127.944-.126 1.438-.192.373-.527.814-1.004 1.321l-4.61 4.902 3.746 10.701-2.304 2.434-5.506-8.832-4.808 5.087-.373 5.24L7.07 25.32l-.93-6.58L0 17.676l1.726-1.832 4.943-.35 4.75-5.042z",
  fillRule: "evenodd"
});

var SvgAirport = function SvgAirport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAirport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/airport.160ae97b.svg";
export { ForwardRef as ReactComponent };